(function () {
  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function moneyText(element) {
    return element ? element.textContent.trim() : '';
  }

  function initReveal() {
    var items = document.querySelectorAll('.spicy-reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.14 });
    items.forEach(function (item) { observer.observe(item); });
  }

  function initScrollButtons() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-spicy-scroll]');
      if (!trigger) return;
      var target = document.querySelector(trigger.getAttribute('data-spicy-scroll') || '#SpicyProduct');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function initCarousels() {
    document.querySelectorAll('[data-spicy-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-spicy-track]');
      var cards = Array.prototype.slice.call(carousel.querySelectorAll('[data-spicy-card]'));
      var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-spicy-dot]'));
      if (!track || !cards.length) return;

      function setActive(index) {
        dots.forEach(function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === index);
          dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
        });
      }

      function nearestCard() {
        var center = track.scrollLeft + track.clientWidth / 2;
        var index = 0;
        var distance = Infinity;
        cards.forEach(function (card, cardIndex) {
          var cardCenter = card.offsetLeft + card.offsetWidth / 2;
          var currentDistance = Math.abs(cardCenter - center);
          if (currentDistance < distance) {
            distance = currentDistance;
            index = cardIndex;
          }
        });
        setActive(index);
      }

      var frame;
      track.addEventListener('scroll', function () {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(nearestCard);
      }, { passive: true });
      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          cards[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });
      });
      setActive(0);
    });
  }

  function initGallery(section) {
    var slidesWrap = section.querySelector('[data-spicy-gallery-slides]');
    var thumbsWrap = section.querySelector('[data-spicy-gallery-thumbs]');
    var prev = section.querySelector('[data-spicy-gallery-prev]');
    var next = section.querySelector('[data-spicy-gallery-next]');
    var index = 0;

    function items() {
      return {
        slides: Array.prototype.slice.call(section.querySelectorAll('[data-spicy-gallery-slide]')),
        thumbs: Array.prototype.slice.call(section.querySelectorAll('[data-spicy-gallery-thumb]'))
      };
    }

    function show(nextIndex) {
      var collection = items();
      if (!collection.slides.length) return;
      index = (nextIndex + collection.slides.length) % collection.slides.length;
      collection.slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle('is-active', slideIndex === index);
      });
      collection.thumbs.forEach(function (thumb, thumbIndex) {
        thumb.classList.toggle('is-active', thumbIndex === index);
        thumb.setAttribute('aria-current', thumbIndex === index ? 'true' : 'false');
      });
      if (collection.thumbs[index]) {
        collection.thumbs[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    }

    function bindThumbs() {
      items().thumbs.forEach(function (thumb, thumbIndex) {
        thumb.addEventListener('click', function () { show(thumbIndex); });
      });
    }

    function replace(blockId) {
      var template = section.querySelector('template[data-spicy-gallery-template="' + blockId + '"]');
      if (!template || !slidesWrap || !thumbsWrap) return;
      var sourceSlides = template.content.querySelector('[data-template-slides]');
      var sourceThumbs = template.content.querySelector('[data-template-thumbs]');
      if (!sourceSlides || !sourceThumbs) return;
      slidesWrap.innerHTML = sourceSlides.innerHTML;
      thumbsWrap.innerHTML = sourceThumbs.innerHTML;
      index = 0;
      bindThumbs();
      show(0);
    }

    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    bindThumbs();
    show(0);
    return { replace: replace };
  }

  function initProducts() {
    document.querySelectorAll('[data-spicy-product]').forEach(function (section) {
      var offers = Array.prototype.slice.call(section.querySelectorAll('[data-spicy-offer]'));
      var variantInput = section.querySelector('input[name="id"]');
      var submit = section.querySelector('[data-spicy-submit]');
      var submitLabel = section.querySelector('[data-spicy-submit-label]');
      var stock = section.querySelector('[data-spicy-stock]');
      var title = section.querySelector('[data-spicy-product-title]');
      var stickyImage = section.querySelector('[data-spicy-sticky-image]');
      var stickyTitle = section.querySelector('[data-spicy-sticky-title]');
      var gallery = initGallery(section);
      if (!offers.length || !variantInput || !submit) return;

      function select(offer) {
        offers.forEach(function (card) {
          var selected = card === offer;
          card.classList.toggle('is-selected', selected);
          card.setAttribute('aria-checked', selected ? 'true' : 'false');
        });
        var available = offer.dataset.available === 'true';
        variantInput.value = offer.dataset.variantId || '';
        variantInput.disabled = false;
        submit.disabled = !available;
        submit.setAttribute('aria-disabled', available ? 'false' : 'true');
        if (submitLabel) {
          submitLabel.textContent = available ? ((submit.dataset.label || 'Add to cart') + ' - ' + moneyText(offer.querySelector('[data-spicy-offer-price]'))) : (submit.dataset.soldLabel || 'Sold out');
        }
        if (stock) {
          stock.hidden = !available;
        }
        if (title && offer.dataset.productTitle) {
          title.textContent = offer.dataset.productTitle;
        }
        if (stickyTitle && offer.dataset.productTitle) {
          stickyTitle.textContent = offer.dataset.productTitle;
        }
        if (stickyImage && offer.dataset.productImage) {
          stickyImage.src = offer.dataset.productImage;
          stickyImage.alt = offer.dataset.productTitle || '';
        }
        if (gallery && offer.dataset.blockId) gallery.replace(offer.dataset.blockId);
      }

      offers.forEach(function (offer) {
        offer.addEventListener('click', function () { select(offer); });
      });
      select(section.querySelector('[data-spicy-offer].is-selected') || offers[0]);
    });
  }

  function initTabs() {
    document.querySelectorAll('[data-spicy-tabs]').forEach(function (tabs) {
      var buttons = Array.prototype.slice.call(tabs.querySelectorAll('[data-spicy-tab-button]'));
      var panels = Array.prototype.slice.call(tabs.querySelectorAll('[data-spicy-tab-panel]'));
      buttons.forEach(function (button, index) {
        button.addEventListener('click', function () {
          buttons.forEach(function (item, itemIndex) {
            item.classList.toggle('is-active', itemIndex === index);
            item.setAttribute('aria-selected', itemIndex === index ? 'true' : 'false');
          });
          panels.forEach(function (panel, panelIndex) {
            panel.classList.toggle('is-active', panelIndex === index);
            panel.hidden = panelIndex !== index;
          });
        });
      });
    });
  }

  function initReviews() {
    document.querySelectorAll('[data-spicy-reviews]').forEach(function (section) {
      var button = section.querySelector('[data-spicy-reviews-toggle]');
      var cards = Array.prototype.slice.call(section.querySelectorAll('[data-spicy-review-card]'));
      if (!button || cards.length <= 3) {
        if (button) button.hidden = true;
        return;
      }
      var open = false;
      function render() {
        cards.forEach(function (card, index) { card.classList.toggle('is-hidden', !open && index >= 3); });
        button.textContent = open ? button.dataset.lessLabel : button.dataset.moreLabel;
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      button.addEventListener('click', function () { open = !open; render(); });
      render();
    });
  }

  function initStickyBuy() {
    document.querySelectorAll('[data-spicy-product]').forEach(function (section) {
      var sticky = section.querySelector('[data-spicy-sticky-buy]');
      if (!sticky) return;
      function update() {
        var bounds = section.getBoundingClientRect();
        sticky.classList.toggle('is-visible', bounds.bottom < 0);
      }
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function initFooter() {
    var groups = Array.prototype.slice.call(document.querySelectorAll('.spicy-footer__group'));
    if (!groups.length || !window.matchMedia) return;
    var mobile = window.matchMedia('(max-width: 749px)');
    function update(event) {
      groups.forEach(function (group) {
        if (event.matches) group.removeAttribute('open');
        else group.setAttribute('open', '');
      });
    }
    update(mobile);
    if (mobile.addEventListener) mobile.addEventListener('change', update);
    else mobile.addListener(update);
  }

  onReady(function () {
    initReveal();
    initScrollButtons();
    initCarousels();
    initProducts();
    initTabs();
    initReviews();
    initStickyBuy();
    initFooter();
  });
})();
